import React from 'react'
import { Wall } from './Wall/Wall'
import { JoistsDisplay } from './JoistsDisplay'
import { useFloorPlanState } from '../../../../../../../stateProviders/FloorPlanStateProvider'
import { WallStateProvider } from '../../../../../../../stateProviders/WallStateProvider'

//SVG elements do not have a z-index property, so the order in which they are rendered is the order in which they are displayed
//This means that later rendered elements will be displayed on top of earlier rendered elements
export const Geometries = () => {

    const floorPlanState = useFloorPlanState()

    const cornerCircles = floorPlanState.corners.map((corner, index) => {
        return <circle key={index} cx={corner.x} cy={corner.y} r={5/floorPlanState.zoomLevel} fill={index === 0 ? 'red' : 'blue'}/>
    })

    return (<>
        {floorPlanState.corners.map((corner, index) => {
                
            if(floorPlanState.corners.length === 0) return

            return (<React.Fragment key={index - 1}>
                {/* A wall can only be made with at least 2 coordinates */}
                {floorPlanState.corners.length > 1 && index !== 0 &&(
                    <WallStateProvider 
                        wallIndex={index-1} 
                        coordinates={{
                            x1:floorPlanState.corners[index-1].x,
                            y1:floorPlanState.corners[index-1].y,
                            x2:corner.x,
                            y2:corner.y
                        }}
                    >
                    <Wall/>
                    </WallStateProvider>
                )}
                </React.Fragment>)
                
        })}
        {floorPlanState.showJoists && (
            <JoistsDisplay/>
        )}
        {/* Show a dot for each corner */}
        {cornerCircles}
    </>)
}